var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({attrs:{"color":_vm.buttonColor,"icon":_vm.iconOnly}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v(_vm._s(_vm.buttonIcon))])],1)]}}])},[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }